import React, { useState } from 'react';
import { useSettings } from '../contexts/SettingsContext';

/**
 * BrandCornerTag — a small persistent brand pill pinned to a page corner, showing the
 * configured application logo + name (from the super-admin settings via SettingsContext).
 *
 * Built for public, unauthenticated pages (AI interview launch, slot booking) so they carry
 * the platform's branding instead of a generic look. Falls back to a monogram if the logo
 * asset can't be loaded.
 */
const BrandCornerTag = ({ position = 'top-left' }) => {
  const { settings } = useSettings();
  const name = settings?.app?.name || 'Wizbox';
  const logo = settings?.app?.logo;
  const [logoBroken, setLogoBroken] = useState(false);

  const pos = position === 'top-right' ? 'right-4 top-4' : 'left-4 top-4';

  return (
    <div
      className={`fixed ${pos} z-[60] flex items-center gap-2 rounded-full border border-slate-200/70 bg-white/85 px-3 py-1.5 shadow-sm backdrop-blur dark:border-white/10 dark:bg-white/[0.08]`}
    >
      {logo && !logoBroken ? (
        <img
          src={logo}
          alt={name}
          className="h-4 w-4 object-contain"
          onError={() => setLogoBroken(true)}
        />
      ) : (
        <span className="flex h-4 w-4 items-center justify-center rounded bg-gradient-to-br from-indigo-500 to-violet-600 text-[9px] font-bold uppercase text-white">
          {String(name).slice(0, 1)}
        </span>
      )}
      <span className="text-xs font-semibold text-slate-700 dark:text-slate-200">{name}</span>
    </div>
  );
};

export default BrandCornerTag;
